import * as React from 'react';

function SvgCloudUpload(props) {
  return (
    <svg viewBox="0 0 15 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="#63656a">
        <path d="M7.61 4.854a.14.14 0 00-.22 0l-1.96 2.5a.14.14 0 00.11.228h1.293v4.277c0 .077.063.141.14.141h1.05c.077 0 .14-.064.14-.141V7.584H9.46a.14.14 0 00.11-.228z" />
        <path d="M12.512 3.514C11.746 1.46 9.792 0 7.503 0 5.215 0 3.261 1.459 2.494 3.512A3.394 3.394 0 000 6.8c0 1.879 1.498 3.4 3.347 3.4h.67a.135.135 0 00.135-.136v-1.02a.135.135 0 00-.134-.136h-.671a2.049 2.049 0 01-1.49-.64 2.125 2.125 0 01-.585-1.541 2.111 2.111 0 011.546-1.969l.634-.168.233-.622A4.14 4.14 0 015.16 2.042a4.01 4.01 0 012.343-.752c.846 0 1.656.26 2.344.752a4.142 4.142 0 011.475 1.926l.231.62.633.17A2.113 2.113 0 0113.728 6.8c0 .563-.216 1.093-.608 1.49s-.912.618-1.467.618h-.67a.135.135 0 00-.135.136v1.02c0 .075.06.136.134.136h.671C13.502 10.2 15 8.678 15 6.8c0-1.576-1.056-2.902-2.488-3.286z" />
      </g>
    </svg>
  );
}

export default SvgCloudUpload;
